import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkItemPreviewComponent } from './work-item-preview.component';
import { ChatViewerModule } from 'shared/components/chat-viewer/chat-viewer.module';
import { EmailThreadPreviewModule } from 'components/queue-view/queue-view-tab/work-item-preview/email-thread-preview/email-thread-preview.module';
import { MessagingPreviewModule } from 'components/queue-view/queue-view-tab/work-item-preview/messaging-preview/messaging-preview.module';
import { PreviewHeaderModule } from 'components/queue-view/queue-view-tab/work-item-preview/preview-header/preview-header.module';
import { DetailedDataModule } from 'shared/components/detailed-data/detailed-data.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { AssignmentHistoryModule } from 'shared/components/assignment-history/assignment-history.module';

@NgModule({
  imports: [
    CommonModule,
    ChatViewerModule,
    EmailThreadPreviewModule,
    MessagingPreviewModule,
    PreviewHeaderModule,
    DetailedDataModule,
    VisitorHistoryModule,
    AssignmentHistoryModule
  ],
  declarations: [
    WorkItemPreviewComponent
  ],
  exports: [
    WorkItemPreviewComponent
  ]
})
export class WorkItemPreviewModule {}
